import React, { useState } from 'react';

function Home() {
  const [formData, setFormData] = useState({
    streetAddress: '',
    city: '',
    state: '',
    zip: '',
    email: '',
    phone: '',
    agree: false,
  });

  const [message, setMessage] = useState('');

  // Handle input change with validation for phone number formatting
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    if (name === 'phone') {
      // Validate and format phone number input
      const formattedPhone = formatPhoneNumber(value);
      setFormData({
        ...formData,
        phone: formattedPhone,
      });
    } else {
      setFormData({
        ...formData,
        [name]: type === 'checkbox' ? checked : value,
      });
    }
  };

  // Format phone number as (123) 456-7890
  const formatPhoneNumber = (value) => {
    // Remove all non-numeric characters
    const cleaned = value.replace(/\D/g, '');

    // Limit the number of digits to 10 (for US-based phone numbers)
    if (cleaned.length > 10) {
      return value.slice(0, 14);  // Keep formatting intact but limit input
    }

    // Format to (123) 456-7890
    const match = cleaned.match(/^(\d{0,3})(\d{0,3})(\d{0,4})$/);
    if (match) {
      const part1 = match[1] ? `(${match[1]}` : '';
      const part2 = match[2] ? `) ${match[2]}` : '';
      const part3 = match[3] ? `-${match[3]}` : '';
      return `${part1}${part2}${part3}`.trim();
    }

    return value;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Basic form validation
    if (!formData.agree) {
      setMessage('You must agree to be contacted.');
      return;
    }

    try {
      const response = await fetch('/api/contact', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      });

      if (response.ok) {
        setMessage('Your information has been submitted!');
        setFormData({
          streetAddress: '',
          city: '',
          state: '',
          zip: '',
          email: '',
          phone: '',
          agree: false,
        });
      } else {
        setMessage('There was an error submitting your information.');
      }
    } catch (error) {
      setMessage('There was a network error. Please try again.');
    }
  };

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gradient-to-r from-indigo-500 to-purple-500 text-white">
      <div className="w-full max-w-3xl text-center py-20">
        <h1 className="text-5xl font-bold mb-6">Get a Cash Offer on Your Home</h1>
        <p className="text-xl mb-8">Enter your details below, and we’ll provide you with a competitive offer.</p>
      </div>

      <form onSubmit={handleSubmit} className="bg-white text-gray-900 p-8 rounded-lg shadow-lg w-full max-w-xl">
        {/* Street Address */}
        <div className="mb-6">
          <label className="block text-gray-700 text-lg font-medium mb-2">Street Address</label>
          <input
            type="text"
            name="streetAddress"
            value={formData.streetAddress}
            onChange={handleChange}
            className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:border-indigo-500"
            placeholder="123 Main St"
            maxLength="100"
            required
          />
        </div>

        {/* City */}
        <div className="mb-6">
          <label className="block text-gray-700 text-lg font-medium mb-2">City</label>
          <input
            type="text"
            name="city"
            value={formData.city}
            onChange={handleChange}
            className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:border-indigo-500"
            placeholder="Your City"
            maxLength="50"
            required
          />
        </div>

        {/* State */}
        <div className="mb-6">
          <label className="block text-gray-700 text-lg font-medium mb-2">State</label>
          <input
            type="text"
            name="state"
            value={formData.state}
            onChange={handleChange}
            className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:border-indigo-500"
            placeholder="Your State"
            maxLength="2"
            required
          />
        </div>

        {/* Zip Code */}
        <div className="mb-6">
          <label className="block text-gray-700 text-lg font-medium mb-2">Zip Code</label>
          <input
            type="text"
            name="zip"
            value={formData.zip}
            onChange={handleChange}
            className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:border-indigo-500"
            placeholder="12345"
            maxLength="5"
            pattern="\d{5}"
            required
          />
        </div>

        {/* Email */}
        <div className="mb-6">
          <label className="block text-gray-700 text-lg font-medium mb-2">Email Address</label>
          <input
            type="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:border-indigo-500"
            placeholder="you@example.com"
            maxLength="100"
            required
          />
        </div>

        {/* Phone */}
        <div className="mb-6">
          <label className="block text-gray-700 text-lg font-medium mb-2">Phone Number</label>
          <input
            type="tel"
            name="phone"
            value={formData.phone}
            onChange={handleChange}
            className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:border-indigo-500"
            placeholder="(123) 456-7890"
            maxLength="14"  // Limit to 14 characters to include the phone number formatting
            required
          />
        </div>

        {/* Agreement */}
        <div className="mb-6">
          <label className="block text-gray-700 text-lg font-medium">
            <input
              type="checkbox"
              name="agree"
              checked={formData.agree}
              onChange={handleChange}
              className="mr-2"
              required
            />
            I agree to be contacted about my submission
          </label>
        </div>

        {/* Submit Button */}
        <button type="submit" className="w-full bg-indigo-600 text-white text-lg font-semibold p-3 rounded-lg hover:bg-indigo-500 transition duration-300">
          Get Your Offer
        </button>

        {/* Message */}
        {message && <p className="mt-6 text-red-500 text-lg">{message}</p>}
      </form>

      {/* Footer */}
      <footer className="mt-20 text-gray-300 text-sm">
      </footer>
    </div>
  );
}

export default Home;

